'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.getJobsWithSectors = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getAllMatchingJobs = require('shared/utils/getAllMatchingJobs');

var _getAllMatchingJobs2 = _interopRequireDefault(_getAllMatchingJobs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getJobsWithSectors = exports.getJobsWithSectors = function getJobsWithSectors(_ref) {
  var data = _ref.data,
      user = _ref.user;

  return (0, _getAllMatchingJobs2.default)({
    user: user,
    data: data
  }).map(function (job) {
    return (0, _extends3.default)({}, job, {
      subsectors: job.subsectors.map(function (subsector) {
        return data.subsectors[subsector];
      }),
      userSkills: user.skills
    });
  });
}; // import getMatchingJobs from 'shared/utils/match/getMatchingJobs';
//import arrayAsObj from 'shared/utils/arrayAsObj';
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref2) {
  var jobs = _ref2.jobs;
  return {
    jobs: getJobsWithSectors(state, jobs)
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobList/selectors.js
// module id = 1187
// module chunks = 0